@use "sass:string";
@use "../../styles/breakpoint.module" as *;

$image-width: 400;

.item {
    position: relative;
    display: flex;
    align-items: flex-end;
    width: #{$image-width}px;
    max-width: var(--mobile-item-width);
    aspect-ratio: 404 / 435;
    margin: 0;
    padding-bottom: var(--spacer-16);

    &:has(a) {
        cursor: pointer;
    }
}

.imageContainer {
    position: absolute;
    top: 0;
    right: 0;
    aspect-ratio: 326 / 435;
    height: 100%;
    overflow: hidden;
    border-radius: 2px;

    .item:has(.caption:not(:empty)) &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-20);
    }
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.caption {
    position: relative;
    z-index: 1;
}

:export {
    sizes: string.unquote("#{$image-width}px");
}
